import { lazy } from 'react'
import { Navigate, Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'
import { LeaveLayout } from './components/leaveLayout/leaveLayout'

const LeaveConfigPage = lazy(() => import('./pages/leaveConfig'))
const LeaveApprovalsPage = lazy(() => import('./pages/leaveApprovals'))
const LeaveCalendarPage = lazy(() => import('./pages/leaveCalendar'))

export const leaveRoutes = () => {
  return (
    <>
      <Route element={<LeaveLayout />}>
        <Route
          path={pageUrl.leave}
          element={<Navigate to={pageUrl.leaveConfig} replace />}
        />
        <Route path={pageUrl.leaveConfig} element={<LeaveConfigPage />} />
        <Route
          path={pageUrl.leaveApprovals}
          element={<LeaveApprovalsPage />}
        />
        <Route path={pageUrl.leaveCalendar} element={<LeaveCalendarPage />} />
      </Route>
    </>
  )
}
